import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	collectContactInfo: {
		isLoading: false,
		hasCompleted: false,
		error: undefined,
		data: {}
	},
	collectContactInfoPayload: {
		data: {}
	}
};

export const collectContactInfoSlice = createSlice({
	name: 'collectContactInfo',
	initialState,
	reducers: {
		collectContactInfo: (state) => {
			state.collectContactInfo.isLoading = true;
		},
		collectContactInfoCompleted: (state, action) => {
			state.collectContactInfo.isLoading = false;
			state.collectContactInfo.hasCompleted = true;
			state.collectContactInfo.data = action.payload;
		},
		collectContactInfoFailed: (state, action) => {
			state.collectContactInfo.isLoading = false;
			state.collectContactInfo.error = action.payload;
		},
		collectContactInfoReset: (state) => {
			state.collectContactInfo = initialState.collectContactInfo;
			state.collectContactInfoPayload = initialState.collectContactInfoPayload;
		},
		collectContactInfoPayload: (state, action) => {
			state.collectContactInfoPayload.data = action.payload;
		}
	}
});

export const {
	collectContactInfo,
	collectContactInfoPayload,
	collectContactInfoCompleted,
	collectContactInfoFailed,
	collectContactInfoReset
} = collectContactInfoSlice.actions;

export default collectContactInfoSlice.reducer;
